<template>
    <div
        class="z-999 sm:z-40 bg-white absolute w-full h-screen mx-auto sm:pl-16 lg:px-20 right-0 opacity-95"
    >
        <router-link to="/" class="right-0 absolute p-2">
            <img
                src="images/close.png"
                class="bg-el-right p-2 h-10 w-10 rounded-full"
            />
        </router-link>
        <div class="mt-10">
            <div class="grid grid-cols-1">
                <div class="p-4 pl-10 lg:pl-32 lg:p-32 py-10 text-left">
                    <h1
                        class="text-base text-color-1 font-montserrat font-semibold mb-6"
                    >
                        Questions fréquentes sur le Cadastre Solaire Maroc
                    </h1>

                    <div id="accordion" class="accordion-container">
                        <div
                            v-for="(item, index) in items"
                            :key="index"
                            :class="[
                                'accordion m-6 cursor-pointer',
                                { 'is-open': isOpen.includes(index) }
                            ]"
                        >
                            <div
                                class="text-base text-color-1 font-montserrat font-medium"
                                @click="toggleAccordion(index)"
                            >
                                {{ item.title }}
                            </div>
                            <div class="accordion-body">
                                <p
                                    class="leading-relaxed font-montserrat text-color-5 text-left text-sm whitespace-normal align-middle font-light p-4"
                                >
                                    {{ item.text }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            items: [
                {
                    title: "1. Qu'est-ce que le Cadastre Solaire Maroc ?",
                    text:
                        "Le Cadastre Solaire Maroc est un outil open source, basé sur une carte interactive en ligne, donnant le potentiel solaire des toitures des bâtiments ainsi que l'investissement estimé nécessaire."
                },
                {
                    title: "2. Comment fonctionne le Cadastre Solaire Maroc ?",
                    text:
                        "L'outil utilise des données photogrammétriques pour créer un modèle tridimensionnel de l'ensemble de la topologie urbaine. Ce modèle est ensuite analysé pour l'accès solaire en tenant compte de la forme du toit, de son orientation, et de son élévation."
                },
                {
                    title:
                        "3. Le Cadastre Solaire Maroc considère-t-il l’ombrage ?",
                    text:
                        "Oui. Le Cadastre Solaire Maroc prend en compte l'ombrage de tous les bâtiments, des structures environnantes et des reliefs proches et lointains."
                },
                {
                    title:
                        "4. Le Cadastre Solaire Maroc remplace-t-il une évaluation sur site ?",
                    text:
                        "Le Cadastre Solaire Maroc est un outil d'évaluation à distance. Cependant, il ne remplace pas une évaluation sur place effectuée par un professionnel certifié."
                },
                {
                    title:
                        "5.	Quels sont les principaux facteurs qui peuvent entraîner des écarts de prédiction ou des données manquantes ?",
                    text:
                        "Les résultats du système solaire peuvent être indisponibles ou inexacts en raison de problèmes tels que l'obsolescence partielle de l'échantillon, un excès de végétation ou des obstructions non modélisées, des bases de données incomplètes ou corrompues, des couches SIG incomplètes ou corrompues, et des obstructions partielles indétectables basées sur la résolution de l'enquête, entre autres."
                }
            ],
            isOpen: []
        };
    },
    methods: {
        toggleAccordion(index) {
            if (this.isOpen.includes(index)) {
                this.isOpen = this.isOpen.filter(i => i !== index);
                return;
            }

            this.isOpen.push(index);

        }
    }
};
</script>
